import React from 'react';
import Icon from 'SF/MaterialIcon';
import css from './CalendarLockIcon.scss';

const CalendarLockIcon = () => {
    return (
        <div className={css['calendar-lock']} aria-label="Calendar Administrator">
            <Icon className={css['calendar']} icon="today" aria-hidden={true} />
            <div className={css['whiteout']} />
            <Icon className={css['key']} icon="vpn_key" aria-hidden={true} />
        </div>
    );
};

export default CalendarLockIcon;
